import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CustomErrorView } from '../../components/custom-error-view/custom-error-view';

const notFound = '/assets/images/not_found.svg';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <CustomErrorView
      image={notFound}
      title={t('NOT_FOUND_TEXT')}
      description={t('PAGE_MAY_MOVED_NO_LONGER_EXISTS')}
      buttonText={t('TAKE_ME_BACK')}
      buttonIcon={<ArrowRight />}
      buttonLink="/"
    />
  );
};
